import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Old `/spare-libraries/:id/edit` bookmarks → list modal. */
export const SpareLibraryEditRedirect: React.FC = () => {
  const { id } = useParams();
  const n = id != null ? Number(id) : NaN;
  if (!Number.isFinite(n) || n <= 0) {
    return <Navigate to="/spares/spare-libraries" replace />;
  }
  return <Navigate to={`/spares/spare-libraries?edit=${n}`} replace />;
};
